/**
 * @generated SignedSource<<cb646e162bf4cf53c24e0280537d66ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetencyUpdateMutation$variables = {
  id: number;
  level: number;
};
export type CompetencyUpdateMutation$data = {
  readonly updateCompetency: {
    readonly competency: {
      readonly id: number;
      readonly level: number | null | undefined;
      readonly person: {
        readonly first_name: string;
        readonly id: number;
        readonly last_name: string;
      };
    } | null | undefined;
  };
};
export type CompetencyUpdateMutation = {
  response: CompetencyUpdateMutation$data;
  variables: CompetencyUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "level"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "level",
        "variableName": "level"
      }
    ],
    "concreteType": "UpdateCompetencyResult",
    "kind": "LinkedField",
    "name": "updateCompetency",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "competencies",
        "kind": "LinkedField",
        "name": "competency",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "level",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "people",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "first_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "last_name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetencyUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetencyUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "50375e915e473a61e271f542774646e8",
    "id": null,
    "metadata": {},
    "name": "CompetencyUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CompetencyUpdateMutation(\n  $id: Int!\n  $level: Int!\n) {\n  updateCompetency(id: $id, level: $level) {\n    competency {\n      id\n      level\n      person {\n        id\n        first_name\n        last_name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44c2d77d247e3915c944ab042d6e8133";

export default node;
